export * from './StrategyInfoSection';
